import {
  Activity,
  AlertTriangle,
  ArrowLeftRight,
  Ban,
  Banknote,
  Calculator,
  CircleSlash,
  CreditCard,
  Layers,
  Tag,
  TicketPercent,
  TimerOff,
  Wallet,
  XCircle,
} from 'lucide-react';
import { Skeleton, StatCard } from '../../../ui';

const icons = {
  total_gross_volume: Wallet,
  total_net_volume: Banknote,
  total_discount: TicketPercent,
  total_txn_count: ArrowLeftRight,
  total_failed_count: XCircle,
  total_declined_count: Ban,
  total_timeout_count: TimerOff,
  total_cancelled_count: CircleSlash,
  pans_issued_count: CreditCard,
  transaction_failure_rate: AlertTriangle,
  avg_transaction_value: Calculator,
  discount_attach_rate: Tag,
  active_pans: Activity,
  total_pans: Layers,
  gross_volume: Wallet,
  net_volume: Banknote,
  discount_total: TicketPercent,
  completed_count: ArrowLeftRight,
  failed_count: XCircle,
  declined_count: Ban,
  timeout_count: TimerOff,
  cancelled_count: CircleSlash,
  failure_rate: AlertTriangle,
};

const cell = 'col-span-12 sm:col-span-6 xl:col-span-3';

const SummaryGrid = ({ metrics = [], loading }) => (
  <div className="grid grid-cols-12 gap-6">
    {loading
      ? Array.from({ length: 8 }, (_, index) => (
          <div key={index} className={`card mb-0 ${cell}`}>
            <div className="card-body">
              <Skeleton w="60%" h="0.9rem" />
              <Skeleton className="mt-3" w="75%" h="1.6rem" />
              <Skeleton className="mt-3" w="40%" h="0.9rem" />
            </div>
          </div>
        ))
      : metrics.map((metric) => {
          const Icon = icons[metric.key];
          return (
            <StatCard
              key={metric.key}
              metric={metric}
              icon={Icon ? <Icon className="w-5 h-5" /> : undefined}
              className={cell}
            />
          );
        })}
  </div>
);

export default SummaryGrid;
